export const CURRENCY_MASK_CONFIG = {
    VN_MONEY: { prefix: '', thousands: ',', precision: 0 },
    VN_QUANTITY: { prefix: '', thousands: ',', precision: 0 },
    PERCENT: { prefix: '', thousands: ',', precision: 3 }
};
